<template>
  <div class="version-banner-wrapper" v-if="showBanner">
    <div class="version-banner">
      <div class="version-banner-text">A new version of SmartSalesTool is available.</div>
      <div class="version-banner-actions">
        <button class="btn btn-sm btn-primary" @click="refreshNow">Refresh Now</button>
        <i @click="dismiss" class="fa fa-times-circle pointer" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VersionBanner',
  data() {
    return {
      dismissedVersion: null,
    }
  },
  computed: {
    serverAppVersion() {
      return this.$store.state.serverAppVersion;
    },
    showBanner() {
      // VUE_APP_BUILD_VERSION is only baked in by the CI pipeline (build-hsus-uat/build-prod).
      // Local dev (npm run serve) never sets it, so without this guard the banner would compare
      // the real server version against `undefined` and show permanently - reloading can't fix
      // that, since the dev server just re-serves the same already-compiled bundle.
      return !!process.env.VUE_APP_BUILD_VERSION
        && !!this.serverAppVersion
        && this.serverAppVersion !== process.env.VUE_APP_BUILD_VERSION
        && this.dismissedVersion !== this.serverAppVersion;
    }
  },
  methods: {
    refreshNow() {
      window.location.reload();
    },
    dismiss() {
      this.dismissedVersion = this.serverAppVersion;
      localStorage.setItem('versionBannerDismissedFor', this.serverAppVersion);
    }
  },
  created() {
    this.dismissedVersion = localStorage.getItem('versionBannerDismissedFor');
  }
};
</script>

<style lang="scss" scoped>
  .version-banner-wrapper {
    min-height: 25px;
    width: 100%;
    color: black;
    background-color: rgb(63, 130, 232);
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow-wrap: anywhere;
    padding: 10px;
    margin-bottom: 15px;

    .version-banner {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .version-banner-text {
        flex: 1;
        text-align: center;
      }
      .version-banner-actions {
        display: flex;
        align-items: center;
        gap: 10px;
        white-space: nowrap;
      }
    }
  }
</style>
